import styled, { css } from 'styled-components';
import { Switch } from 'antd';

export const StyledSwitch = styled(Switch)`
  &.ant-switch {
    display: block;
    background-color: ${({ theme }) => theme.default.colors.dataVisualization.gray.dark};
    &.ant-switch-checked {
      background-color: ${({ theme }) => theme.default.colors.dataVisualization.purple.base};
    }
  }
`;

export const SwitchLabel = styled.label`
  display: block;
  font-size: 12px;
  line-height: 14px;
  color: #1a2535;
  margin-bottom: 6px;
  text-align: center;
`;

export const SwitchContainer = styled.div`
  display: block;
`;

// The designs' 38x19 toggle used across the invite modals. Interpolate it into the container
// holding the toggle.
export const compactSwitch = css`
  .ant-switch {
    width: 38px !important;
    min-width: 38px !important;
    height: 19px !important;
    line-height: 19px !important;
    padding: 0 !important;
  }
  .ant-switch-handle {
    width: 17px;
    height: 17px;
    top: 1px;
    left: 1px;
  }
  .ant-switch-checked .ant-switch-handle {
    left: calc(100% - 18px);
  }
`;
